import React from 'react'

import "../../styles/img-para.scss"

const ImgPara = (props) => {
    return (
        <div className={`content ${props.shaded}`}>
            {props.children}
        </div>
    )
}

export default ImgPara
